import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=76899391&scoped=true&"
import script from "./Employee.vue?vue&type=script&lang=ts&"
export * from "./Employee.vue?vue&type=script&lang=ts&"
import style0 from "./Employee.vue?vue&type=style&index=0&id=76899391&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76899391",
  null
  
)

export default component.exports